module.exports = __webpack_public_path__ + "static/media/key.bc035eeb.svg";